import {AbstractRepository} from './AbstractRepository';
import {CatalogEntity} from '../Entity/CatalogEntity';
import {CatalogModel} from '../Model/CatalogModel';
import {catalogMapper} from '../Mapper/CatalogMapper';

export interface CatalogsFilters {}

export class CatalogsRepository extends AbstractRepository<CatalogEntity, CatalogsFilters> {
  protected readonly baseUrl: string = 'catalog';

  async findOneById(id: string): Promise<CatalogEntity | undefined> {
    const url: string = `${this.baseUrl}/${id}`;

    const catalogModel = await this.apiService.get<CatalogModel>(url);

    if (catalogModel) {
      return catalogMapper(catalogModel);
    }

    return;
  }
}
